import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = { class: "_pos-r _cur-p _pa-3" }
const _hoisted_3 = {
  key: 0,
  class: "gfu-dcc-wrapper__badges"
}
const _hoisted_4 = { class: "_flex _ai-c" }
const _hoisted_5 = {
  class: "_flexcol",
  "data-qa": "value"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_badge = _resolveComponent("base-badge")
  const _component_checkbox_field = _resolveComponent("checkbox-field")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
             '_mt-3 _ba-2 _rounded--common',
             $props.modelValue === $props.checkedValue
                 ? '_bc--primary'
                 : '_bc--input'
         ]),
    onClick: _cache[0] || (_cache[0] = (...args) => ($options.handleClick && $options.handleClick(...args))),
    "data-qa": `dcc-currency-section:${$props.labelText}`
  }, [
    _createElementVNode("div", _hoisted_2, [
      ($props.labelText)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_base_badge, {
              class: "_mr-1 _my-1",
              theme: $options.theme,
              "data-qa": `dcc-badge:${$props.labelText}`
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($props.labelText), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["theme", "data-qa"])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_checkbox_field, {
          "model-value": $props.modelValue,
          "checked-value": $props.checkedValue,
          name: $props.checkboxGroupName,
          condensed: true,
          class: "_mt-0 _mr-2",
          type: "radio"
        }, null, 8 /* PROPS */, ["model-value", "checked-value", "name"]),
        _createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ])
    ])
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}